import React from 'react';
import App from './App.jsx';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { Router } from 'react-router-dom';
import { registerLocale } from 'react-datepicker';
import en from 'date-fns/locale/en-GB';
import nl from 'date-fns/locale/nl';
import styledComponentsTheme from './common/constants/styledComponentsTheme/styledComponentsTheme';
import overrideMomentLocaleNl from './localization/moment-locale-override/nl';
import { initApi } from './common/api/initApi';
import { history } from './common/history';
import { initStore } from './store';
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { baseTheme } from './theme';

const store = initStore() as any;

export const materialTheme = baseTheme;

registerLocale('en', en);
registerLocale('nl', nl);

initApi(store);

overrideMomentLocaleNl();

if (history.location.hash) {
  history.replace(`/${history.location.hash.replace('#/', '')}`);
}

const Root = () => (
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={materialTheme}>
        <ThemeProvider theme={styledComponentsTheme}>
          <Router history={history}>
            <App />
          </Router>
        </ThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  </Provider>
);

export default Root;
